import React from 'react';
import { SendMessageIcon } from '../common/Icons/SendMessageIcon';

export const SendButton = ({
  isLoading,
  isDisabled,
  onClick,
} : {
  isLoading: boolean
  isDisabled: boolean
  onClick:  (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) => {
  let sendButtonIcon = isLoading ? '' : <SendMessageIcon height={20} width={20} />
  var loadingClass = isLoading ? 'chat-send-button--loading' : '';

  return (
    <button disabled={isLoading || isDisabled} className={'chat-send-button ' + loadingClass} onClick={onClick}>
      {sendButtonIcon}
    </button>
  )
}
